import CommissionRates from "./commissionRates"

export default CommissionRates
